
import { Component, Vue, Prop, Watch, Emit, Mixins, Ref } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import CourseCard from '../CourseCard/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { Observer } from 'mobx-vue'
import LazyImg from '@/components/lazyImg/index.vue'

@Observer
@Component({
  components: {
    Title,
    CourseCard,
    EmptyStatus,
    LazyImg
  }
})
export default class MyCourse extends Vue {
  // 网络出错刷新
  onReload() {
    this.MyClassroomStore.loadMyProductList()
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
